import { EPromoType, IPromoInfoSchema } from '../../../../../types/promo';

export function isMortgageButtonAvailable(promoInfo: IPromoInfoSchema) {
  const isPartner = promoInfo.bank?.isPartner || false;

  return isPartner || promoInfo.promoType === EPromoType.CianMortgage;
}
